import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentModuleResourcesOutput, QueryIntentModuleResourcesArgs } from "types/generated";

export const INTENT_MODULE_RESOURCES: TypedDocumentNode<
  { intentModuleResources: IntentModuleResourcesOutput },
  QueryIntentModuleResourcesArgs
> = gql`
  query IntentModuleResources(
    $intentProjectID: ID!
    $resourceID: ID!
    $first: Int
    $after: String
  ) {
    intentModuleResources(
      intentProjectID: $intentProjectID
      resourceID: $resourceID
      first: $first
      after: $after
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          address
          changedBy
          name
          operation
          provider
          resourceID
          resourceType
          state
          hcl
        }
      }
    }
  }
`;
